export default "__VITE_ASSET__BEBK_KuR__"